export default __webpack_public_path__ + "static/tri-6be8411be6e7b8310e5ade483cc55286.jpg";